import { useState, useEffect, useRef, useCallback } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Dialog } from "primereact/dialog";
import Langs, { Localize } from "../../../app/lang/langs";
import { InputField } from "../../inputs/InputField";
import { DynamicButton } from "../../buttons/DynamicButton";
import { Row } from "primereact/row";
import { Col } from "react-bootstrap";
import moment from "moment";
import { addNews, getDashboardData, markNewsAsRead } from "../../../containers/dashboard/dashboardSlice";
import { showSuccessToast } from "../../../app/utils/helpers";
import TRexAnimation from "./TRexAnimation";
import Box from "@mui/material/Box";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import Typography from "@mui/material/Typography";


export default function AddNewsModal(props) {

    const dispatch = useDispatch()
    const isMobile = useSelector((state) => state.settings.isMobile)
    const [updatedItem, setUpdatedItem] = useState({ title: '', message: '' })
    const [mandatory, setMandatory] = useState(false)
    const [showTRex, setShowTRex] = useState(false)
    const trexFiredRef = useRef(false)

    const mobile = isMobile === 2

    useEffect(() => {
        const matches = /t-?rex/i.test(updatedItem.title);
        if (matches && !trexFiredRef.current) {
            trexFiredRef.current = true;
            setShowTRex(true);
        }
        if (!matches) {
            trexFiredRef.current = false;
        }
    }, [updatedItem.title]);

    const handleTRexComplete = useCallback(() => {
        setShowTRex(false);
    }, []);

    const userId = useSelector((state) => state.login.userId)
    const lastNewsId = useSelector((state) => state.dashboard.lastNewsId)

    const handleFieldChange = (value, field) => {
        setUpdatedItem(prev => ({
            ...prev,
            [field.key]: value
        }))
    }


    const handleMarkAsRead = async () => {
        try {
            await dispatch(markNewsAsRead({
                newsId: props.selectedNews.id,
                userId: userId
            })).unwrap();

            dispatch(getDashboardData({ lastNewsId: lastNewsId }));
        } catch (err) {
            console.error("Error updating news:", err);
        }
    };

    const visibleFields = [
        { key: "title", type: "string", disabled: false },
        { key: "message", type: "text", disabled: false, rows: 6 },
        // { key: "created_by", type: "string", disabled: false },
        // { key: "created_at", type: "date", disabled: false },
    ]

    function getFormatDate(dateKey) {
        if (updatedItem[dateKey]) {
            return moment(updatedItem["dateKey"]).format("YYYY-MM-DD 00:00:00")
        }
        return null
    }

    const handleSave = async () => {
        try {
            const response = await dispatch(
                addNews({
                    title: updatedItem.title,
                    message: updatedItem.message,
                    mandatory: mandatory ? 1 : 0,
                })
            ).unwrap();
            if (response.responseData && response.responseData.status) {
                showSuccessToast(Localize("NEWS_ADDED_SUCCESSFULLY"))
                handleClose();
                dispatch(getDashboardData({ lastNewsId }));
            }
        } catch (error) {
            console.error("Error saving news:", error);
        }
    };


    const footer = () => {
        if (updatedItem["title"].trim() != '' && updatedItem["message"].trim() != '') {
            if (mobile) {
                return (
                    <div style={{ padding: "0" }}>
                        <button
                            onClick={handleSave}
                            style={{
                                width: "100%",
                                padding: "14px",
                                borderRadius: "12px",
                                border: "none",
                                background: "linear-gradient(135deg, #FF9015, #ffab40)",
                                color: "#fff",
                                fontWeight: 600,
                                fontSize: "1rem",
                                letterSpacing: "0.02em",
                                cursor: "pointer",
                                boxShadow: "0 4px 14px rgba(255,144,21,0.25)",
                                transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
                            }}
                        >
                            <Langs str="SEND" />
                        </button>
                    </div>
                )
            }
            return <Row className="d-flex justify-content-center" >
                <Col lg={2} xs={2}>
                    <DynamicButton
                        onClick={handleSave}
                        className='me-auto'
                        title={<Langs str="SEND" />}
                        active={true}
                        color="green"
                    />
                </Col>
            </Row>
        }
    }

    const handleClose = () => {
        setUpdatedItem({ title: '', message: '' })
        setMandatory(false)
        props.setVisible(false)
    }

    return (
        <>
            {showTRex && <TRexAnimation onComplete={handleTRexComplete} />}
            <Dialog
                visible={props.visible}
                style={{
                    width: mobile ? "100%" : "50%",
                    maxHeight: mobile ? "90vh" : undefined,
                    borderRadius: mobile ? "16px 16px 0 0" : "18px",
                    overflow: "hidden",
                    boxShadow: "0 8px 32px rgba(255, 144, 21, 0.10), 0 2px 12px rgba(0, 0, 0, 0.08)",
                    border: mobile ? "none" : "1px solid rgba(255, 144, 21, 0.12)",
                    backdropFilter: "blur(16px)",
                    WebkitBackdropFilter: "blur(16px)",
                    background: "rgba(255, 255, 255, 0.88)",
                    ...(mobile ? { margin: 0, bottom: 0, position: "fixed", left: 0, right: 0, top: "auto" } : {}),
                }}
                contentStyle={{
                    padding: mobile ? "16px" : "24px 28px",
                    background: "transparent",
                }}
                headerStyle={{
                    padding: mobile ? "16px 16px 10px" : "20px 28px 12px",
                    background: "linear-gradient(135deg, rgba(255, 144, 21, 0.06) 0%, rgba(255, 193, 0, 0.04) 100%)",
                    borderBottom: "1px solid rgba(255, 144, 21, 0.10)",
                    fontWeight: 600,
                    letterSpacing: "-0.02em",
                    color: "#2d2a26",
                    fontSize: "1.1rem",
                }}
                onHide={() => {
                    handleClose()
                }}
                header={<Langs str="ADD_NEWS" />}
                draggable={false}
                dismissableMask={false}
                maximizable={false}
                closable={true}
                footer={footer}
                className={mobile ? "add-news-modal-mobile" : ""}
            >
                <div style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "16px",
                    animation: mobile
                        ? "newsModalSlideUp 320ms cubic-bezier(0.4, 0, 0.2, 1) both"
                        : "newsModalFadeIn 280ms cubic-bezier(0.4, 0, 0.2, 1) both",
                }}>
                    {visibleFields.map((field) => (
                        <InputField
                            key={field.key}
                            field={field}
                            onChange={(e) => handleFieldChange(e, field)}
                            value={updatedItem && updatedItem[field.key]}
                        />
                    ))}
                    <Box
                        sx={{
                            p: 1.5,
                            borderRadius: "12px",
                            border: mandatory
                                ? "1px solid rgba(211, 47, 47, 0.28)"
                                : "1px solid rgba(0, 40, 128, 0.14)",
                            backgroundColor: mandatory
                                ? "rgba(211, 47, 47, 0.05)"
                                : "rgba(0, 40, 128, 0.03)",
                            transition: "all 220ms cubic-bezier(0.4, 0, 0.2, 1)",
                        }}
                    >
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={mandatory}
                                    onChange={(event) => setMandatory(event.target.checked)}
                                    sx={{ color: "#002880", "&.Mui-checked": { color: "#d32f2f" } }}
                                />
                            }
                            label={
                                <Typography sx={{ fontSize: "0.875rem", fontWeight: 500 }}>
                                    <Langs str="NEWS_MANDATORY" />
                                </Typography>
                            }
                            sx={{ m: 0 }}
                        />
                        <Typography sx={{ fontSize: "0.75rem", color: "#6b6560", pl: "34px" }}>
                            <Langs str="NEWS_MANDATORY_HINT" />
                        </Typography>
                    </Box>
                </div>
            </Dialog>
            <style>{`
                @keyframes newsModalFadeIn {
                    from { opacity: 0; transform: translateY(8px); }
                    to   { opacity: 1; transform: translateY(0); }
                }
                @keyframes newsModalSlideUp {
                    from { opacity: 0; transform: translateY(40px); }
                    to   { opacity: 1; transform: translateY(0); }
                }
                .p-dialog .p-dialog-header .p-dialog-header-icon:hover {
                    background: rgba(255, 144, 21, 0.10) !important;
                    color: #FF9015 !important;
                    transition: background 220ms cubic-bezier(0.4, 0, 0.2, 1), color 220ms cubic-bezier(0.4, 0, 0.2, 1);
                }
                .add-news-modal-mobile + .p-dialog-mask {
                    backdrop-filter: blur(6px);
                    -webkit-backdrop-filter: blur(6px);
                }
                .add-news-modal-mobile .p-inputtext,
                .add-news-modal-mobile .p-inputtextarea,
                .add-news-modal-mobile textarea,
                .add-news-modal-mobile input {
                    font-size: 16px !important;
                }
                .add-news-modal-mobile .p-dialog-footer {
                    padding: 12px 16px 16px !important;
                }
            `}</style>
        </>
    )
}
